import React, { useState } from "react";
import { toast } from "react-toastify";
import { Modal, Badge } from "../../../components/ui";

import {
    sendProductTariffData,
    deleteProductTariffData,
} from "../../../apis/apis.logistics/apisProduct";

const inputClass =
    "w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";
const inputReadonlyClass = `${inputClass} bg-gray-100 dark:bg-gray-800 cursor-not-allowed`;

function FormRow({ label, children }) {
    return (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:items-center">
            <label className="text-sm font-medium text-gray-600 dark:text-gray-400 sm:text-right">
                {label}
            </label>
            <div>{children}</div>
        </div>
    );
}

export function ProductTariffForm(props) {
    const [showOtherPrices, setShowOtherPrices] = useState(true);

    // Función para calcular precio sin IGV (IGV = 18%)
    const calculatePriceWithoutIGV = (priceWithIGV) => {
        if (!priceWithIGV || priceWithIGV === 0) return 0;
        return (Number(priceWithIGV) / 1.18).toFixed(6);
    };

    // Función para manejar cambios en precios con IGV y calcular automáticamente los sin IGV
    const handleChangeWithIGV = (e) => {
        const { name, value } = e.target;
        const priceWithIGV = Number(value);
        const priceWithoutIGV = calculatePriceWithoutIGV(priceWithIGV);

        // Mapear los nombres de campos con IGV a sus correspondientes sin IGV
        const fieldMapping = {
            priceSaleWholesale: "pricePurchaseWholesale",
            priceSalePrimax: "pricePurchasePrimax",
            priceSaleSunat: "pricePurchaseSunat",
        };

        const correspondingField = fieldMapping[name];

        props.setItemProductTariff((prevState) => ({
            ...prevState,
            [name]: value,
            [correspondingField]: priceWithoutIGV,
        }));
    };

    function handleChange(e) {
        props.setItemProductTariff((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    }

    function handleChangeUnit(e) {
        var index = e.nativeEvent.target.selectedIndex;
        props.setItemProductTariff((prevState) => ({
            ...prevState,
            unitID: e.target.value,
            unitName: e.nativeEvent.target[index].text,
        }));
    }

    const existsUnitInProductTariffs = props.products.find((product) => {
        return Number(product.productID) ==
            Number(props.itemProductTariff.productID)
            ? product.productTariffList.find((tariff) => {
                  return (
                      Number(tariff.unitID) ==
                      Number(props.itemProductTariff.unitID)
                  );
              })
            : false;
    });

    const existsProductTariff = props.products.find((product) => {
        return Number(product.productID) ==
            Number(props.itemProductTariff.productID)
            ? product.productTariffList.find((tariff) => {
                  return (
                      Number(tariff.unitID) ==
                          Number(props.itemProductTariff.unitID) &&
                      Number(tariff.productTariffID) !=
                          Number(props.itemProductTariff.productTariffID)
                  );
              })
            : false;
    });

    const removeProductTariff = props.products.map((product) => {
        if (product.productID === props.itemProductTariff.productID) {
            var newProductItem = Object.assign({}, product);
            newProductItem.productTariffList = product.productTariffList.filter(
                (tariff) =>
                    tariff.productTariffID !=
                    props.itemProductTariff.productTariffID,
            );
            return newProductItem;
        } else {
            return product;
        }
    });

    function updateProductTariff(data) {
        return props.products.map((product) => {
            if (product.productID === data.productID) {
                var newProductItem = Object.assign({}, product);
                newProductItem.productTariffList =
                    product.productTariffList.map((tariff) => {
                        if (
                            Number(tariff.productTariffID) ===
                            Number(data.productTariffID)
                        ) {
                            var newTariffItem = Object.assign({}, tariff);
                            newTariffItem.priceSale = data.priceSale;

                            newTariffItem.priceSaleWholesale =
                                data.priceSaleWholesale;
                            newTariffItem.priceSalePrimax =
                                data.priceSalePrimax;
                            newTariffItem.priceSaleSunat = data.priceSaleSunat;

                            newTariffItem.pricePurchaseWholesale =
                                data.pricePurchaseWholesale;
                            newTariffItem.pricePurchasePrimax =
                                data.pricePurchasePrimax;
                            newTariffItem.pricePurchaseSunat =
                                data.pricePurchaseSunat;

                            newTariffItem.pricePurchase = data.pricePurchase;
                            newTariffItem.percentageDiscount =
                                data.percentageDiscount;
                            newTariffItem.quantityMinimum =
                                data.quantityMinimum;
                            newTariffItem.unitID = data.unitID;
                            newTariffItem.unitName = data.unitName;
                            return newTariffItem;
                        } else {
                            return tariff;
                        }
                    });
                return newProductItem;
            } else {
                return product;
            }
        });
    }

    function createProductTariff(data) {
        return props.products.map((product) => {
            if (
                Number(product.productID) ===
                Number(props.itemProductTariff.productID)
            ) {
                return {
                    ...product,
                    productTariffList: [...product.productTariffList, data],
                };
            } else {
                return product;
            }
        });
    }

    const sendTariff = async (registerData) => {
        try {
            const response = await sendProductTariffData(registerData);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const removeTariff = async (registerData) => {
        try {
            const response = await deleteProductTariffData(registerData);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const handleClickBtnRemove = async () => {
        if (
            window.confirm("¿Estás seguro de que deseas anular esta operación?")
        ) {
            await removeTariff(props.itemProductTariff).then(async (r) => {
                if (r.status == 201 && r.success) {
                    await props.setProducts(removeProductTariff);
                    toast.success("presentacion borrada con exito!");
                } else {
                    toast.error("Ocurrio algun error");
                }
                props.onClose();
            });
        }
    };

    // Construye el payload con valores numéricos saneados (nunca strings vacíos) — evita que un
    // campo opcional sin control visible (ej. "P. V. Tiendas" no aplica para UND en productos que
    // no son grupo) llegue como "" y rompa el parseo de Decimal en el backend.
    const buildSanitizedTariffPayload = () => ({
        ...props.itemProductTariff,
        priceSale: Number(props.itemProductTariff.priceSale) || 0,
        pricePurchase: Number(props.itemProductTariff.pricePurchase) || 0,
        priceSaleWholesale:
            Number(props.itemProductTariff.priceSaleWholesale) || 0,
        priceSalePrimax: Number(props.itemProductTariff.priceSalePrimax) || 0,
        priceSaleSunat: Number(props.itemProductTariff.priceSaleSunat) || 0,
        pricePurchaseWholesale:
            Number(props.itemProductTariff.pricePurchaseWholesale) || 0,
        pricePurchasePrimax:
            Number(props.itemProductTariff.pricePurchasePrimax) || 0,
        pricePurchaseSunat:
            Number(props.itemProductTariff.pricePurchaseSunat) || 0,
        percentageDiscount:
            Number(props.itemProductTariff.percentageDiscount) || 0,
        quantityMinimum: Number(props.itemProductTariff.quantityMinimum) || 0,
    });

    const handleClickBtnSave = async () => {
        if (props.itemProductTariff.unitID == "0") {
            toast.error("Verifique la unidad");
            return;
        }
        if (!(Number(props.itemProductTariff.priceSale) >= 0)) {
            toast.error("Verifique el precio");
            return;
        }
        if (!(Number(props.itemProductTariff.quantityMinimum) > 0)) {
            toast.error("Verifique la cantidad minima");
            return;
        }

        const isNew = props.itemProductTariff.productTariffID == "0";

        if (isNew && existsUnitInProductTariffs != undefined) {
            toast.error("ya existe una presentacion con esa unidad");
            return;
        }
        if (!isNew && existsProductTariff != undefined) {
            toast.error("la presentacion ya existe");
            return;
        }

        const payload = buildSanitizedTariffPayload();

        try {
            const r = await sendTariff(payload);
            const data = { ...payload, productTariffID: r.productTariffID };

            if (isNew) {
                await props.setProducts(createProductTariff(data));
                toast.success("presentacion registrada con exito!");
            } else {
                await props.setProducts(updateProductTariff(data));
                toast.success("presentacion actualizada con exito!");
            }
            await props.setItemProductTariff(props.initialProductTariffState);
            props.onClose();
        } catch (error) {
            toast.error("Ocurrio algun error al guardar la presentacion");
        }
    };

    const tariffTitle = (
        <>
            <i
                className="fas fa-tags text-blue-600 dark:text-blue-400"
                aria-hidden="true"
            />
            <span>{props.itemProductTariff.productSaleName || "Producto"}</span>
            <Badge
                variant={
                    props.itemProduct.isGroup === true ? "success" : "primary"
                }
                className="text-xs ml-2"
            >
                {props.itemProduct.isGroup === true
                    ? "Precios de Venta"
                    : "Precios de Compra"}
            </Badge>
            <Badge variant="secondary" className="text-xs">
                {props.itemProductTariff.productTariffID == "0"
                    ? "Nuevo"
                    : "Editar"}
            </Badge>
        </>
    );

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            title={tariffTitle}
            size="lg"
        >
            <div className="space-y-4 -mt-2">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <FormRow label="Unidad de venta:">
                        <select
                            className={inputClass}
                            name="unitID"
                            onChange={handleChangeUnit}
                            value={props.itemProductTariff.unitID}
                            disabled={
                                props.itemProductTariff.productTariffID != "0"
                            }
                        >
                            <option value="0">Elige</option>

                            {props.units.map((item, index) => {
                                return (
                                    <option key={index} value={item.unitID}>
                                        {item.unitName}
                                    </option>
                                );
                            })}
                        </select>
                    </FormRow>

                    <FormRow label="Cantidad mínima">
                        <input
                            type="number"
                            className={inputClass}
                            placeholder="Ingrese ..."
                            name="quantityMinimum"
                            maxLength={6}
                            value={props.itemProductTariff.quantityMinimum}
                            onChange={(e) => {
                                if (Number(e.target.value) >= 0) {
                                    props.setItemProductTariff((prevState) => ({
                                        ...prevState,
                                        quantityMinimum: e.target.value,
                                    }));
                                    if (
                                        props.itemProductTariff.unitName !==
                                        "UND"
                                    ) {
                                        props.setItemProductTariff(
                                            (prevState) => ({
                                                ...prevState,
                                                priceSale: Number(
                                                    Number(
                                                        props.itemProductTariff
                                                            .pricePurchase,
                                                    ) / Number(e.target.value),
                                                ).toFixed(6),
                                            }),
                                        );
                                    }
                                }
                            }}
                            autoComplete="off"
                        />
                    </FormRow>
                </div>

                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    {/* Precio de venta en tiendas en unidades (solo cabezas de grupo) */}
                    {props.itemProductTariff.unitName == "UND" &&
                        props.itemProduct.isGroup === true && (
                            <FormRow label={"P. V. (Tiendas)"}>
                                <input
                                    type="number"
                                    className={inputClass}
                                    placeholder="Ingrese ..."
                                    name="priceSale"
                                    maxLength={6}
                                    readOnly={
                                        props.itemProductTariff.unitName !==
                                        "UND"
                                    }
                                    value={props.itemProductTariff.priceSale}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                            </FormRow>
                        )}

                    <FormRow
                        label={
                            props.itemProductTariff.unitName == "UND" &&
                            props.itemProduct.isGroup === true
                                ? "P. V. (Público)"
                                : (props.itemProductTariff.unitName == "CJ" ||
                                        props.itemProductTariff.unitName ==
                                            "TIR") &&
                                    props.itemProduct.isGroup === false
                                  ? "Costo Caja"
                                  : "P. V. Caja"
                        }
                    >
                        <input
                            type="number"
                            className={inputClass}
                            placeholder="Ingrese ..."
                            name="pricePurchase"
                            maxLength={6}
                            value={props.itemProductTariff.pricePurchase}
                            onChange={(e) => {
                                if (Number(e.target.value) >= 0) {
                                    props.setItemProductTariff((prevState) => ({
                                        ...prevState,
                                        pricePurchase: e.target.value,
                                    }));
                                    if (
                                        props.itemProductTariff.unitName !==
                                        "UND"
                                    ) {
                                        props.setItemProductTariff(
                                            (prevState) => ({
                                                ...prevState,
                                                priceSale: Number(
                                                    Number(e.target.value) /
                                                        Number(
                                                            props
                                                                .itemProductTariff
                                                                .quantityMinimum,
                                                        ),
                                                ).toFixed(6),
                                            }),
                                        );
                                    }
                                }
                            }}
                            autoComplete="off"
                        />
                    </FormRow>

                    {(props.itemProductTariff.unitName == "CJ" ||
                        props.itemProductTariff.unitName == "TIR") &&
                    props.itemProduct.isGroup === false ? (
                        <FormRow label="% Descuento">
                            <input
                                type="number"
                                className={inputClass}
                                placeholder="Ingrese ..."
                                name="percentageDiscount"
                                maxLength={6}
                                value={
                                    props.itemProductTariff.percentageDiscount
                                }
                                onChange={handleChange}
                                onFocus={(e) => e.target.select()}
                                autoComplete="off"
                            />
                        </FormRow>
                    ) : null}
                </div>
                {/* otros precios de venta */}
                {props.itemProductTariff.unitName == "UND" &&
                props.itemProduct.isGroup === true ? (
                    <div className="space-y-4 border-t border-gray-200 pt-4 dark:border-gray-700">
                        <div className="flex items-center justify-between">
                            <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                                Otros precios
                            </h3>
                            <button
                                type="button"
                                onClick={() =>
                                    setShowOtherPrices(!showOtherPrices)
                                }
                                className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                            >
                                <i
                                    className={`fas fa-chevron-${showOtherPrices ? "up" : "down"}`}
                                />
                            </button>
                        </div>
                        {showOtherPrices && (
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <FormRow label="P. V. Mayorista (CON IGV)">
                                    <input
                                        type="number"
                                        className={inputClass}
                                        placeholder="Ingrese ..."
                                        name="priceSaleWholesale"
                                        maxLength={6}
                                        value={
                                            props.itemProductTariff
                                                .priceSaleWholesale
                                        }
                                        onChange={handleChangeWithIGV}
                                        onFocus={(e) => e.target.select()}
                                        autoComplete="off"
                                    />
                                </FormRow>
                                <FormRow label="C. Mayorista (SIN IGV)">
                                    <input
                                        type="number"
                                        className={inputReadonlyClass}
                                        placeholder="Calculado automáticamente"
                                        name="pricePurchaseWholesale"
                                        maxLength={6}
                                        value={
                                            props.itemProductTariff
                                                .pricePurchaseWholesale
                                        }
                                        readOnly
                                        autoComplete="off"
                                    />
                                </FormRow>
                                <FormRow label="P. V. Primax (CON IGV)">
                                    <input
                                        type="number"
                                        className={inputClass}
                                        placeholder="Ingrese ..."
                                        name="priceSalePrimax"
                                        maxLength={6}
                                        value={
                                            props.itemProductTariff
                                                .priceSalePrimax
                                        }
                                        onChange={handleChangeWithIGV}
                                        onFocus={(e) => e.target.select()}
                                        autoComplete="off"
                                    />
                                </FormRow>
                                <FormRow label="C. Primax (SIN IGV)">
                                    <input
                                        type="number"
                                        className={inputReadonlyClass}
                                        placeholder="Calculado automáticamente"
                                        name="pricePurchasePrimax"
                                        maxLength={6}
                                        value={
                                            props.itemProductTariff
                                                .pricePurchasePrimax
                                        }
                                        readOnly
                                        autoComplete="off"
                                    />
                                </FormRow>
                                <FormRow label="P. V. Sunat (CON IGV)">
                                    <input
                                        type="number"
                                        className={inputClass}
                                        placeholder="Ingrese ..."
                                        name="priceSaleSunat"
                                        maxLength={6}
                                        value={
                                            props.itemProductTariff
                                                .priceSaleSunat
                                        }
                                        onChange={handleChangeWithIGV}
                                        onFocus={(e) => e.target.select()}
                                        autoComplete="off"
                                    />
                                </FormRow>
                                <FormRow label="C. Sunat (SIN IGV)">
                                    <input
                                        type="number"
                                        className={inputReadonlyClass}
                                        placeholder="Calculado automáticamente"
                                        name="pricePurchaseSunat"
                                        maxLength={6}
                                        value={
                                            props.itemProductTariff
                                                .pricePurchaseSunat
                                        }
                                        readOnly
                                        autoComplete="off"
                                    />
                                </FormRow>
                            </div>
                        )}
                    </div>
                ) : null}

                <div className="flex flex-wrap justify-end gap-2 border-t border-gray-200 pt-4 dark:border-gray-700">
                    <button
                        type="button"
                        onClick={props.onClose}
                        className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
                    >
                        Cerrar
                    </button>
                    <button
                        type="button"
                        onClick={handleClickBtnSave}
                        className="rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-green-700"
                    >
                        <i className="fas fa-save mr-1" aria-hidden="true" />
                        Guardar
                    </button>
                    {props.itemProductTariff.productTariffID != "0" && (
                        <button
                            type="button"
                            onClick={handleClickBtnRemove}
                            className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700"
                        >
                            <i
                                className="fas fa-trash mr-1"
                                aria-hidden="true"
                            />
                            Eliminar
                        </button>
                    )}
                </div>
            </div>
        </Modal>
    );
}
